var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-bar-chart-2835073 1",
    clipPath: "url(#clip0_12_686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 12.834H0V13.4173H14V12.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 0.291667C1.75 0.130667 1.88067 0 2.04167 0C2.6005 0 3.81617 0 4.375 0C4.536 0 4.66667 0.130667 4.66667 0.291667C4.66667 2.21404 4.66667 12.9885 4.66667 12.9885H1.75V0.291667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78687 4.13086H5.77153C5.93253 4.13086 6.0632 4.26298 6.0632 4.42603V12.9867H4.78687V4.13086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 3.84049C7.875 3.67949 8.00567 3.54883 8.16667 3.54883C8.7255 3.54883 9.94117 3.54883 10.5 3.54883C10.661 3.54883 10.7917 3.67949 10.7917 3.84049C10.7917 5.43124 10.7917 12.9875 10.7917 12.9875H7.875V3.84049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 3.45032V2.06665C9.33325 1.90361 9.46392 1.77148 9.62492 1.77148C10.1838 1.77148 11.3994 1.77148 11.9583 1.77148C12.1193 1.77148 12.2499 1.90361 12.2499 2.06665V12.9887H10.9074V3.74548C10.9074 3.58244 10.7767 3.45032 10.6157 3.45032H9.33325Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareIcon);
export default __webpack_public_path__ + "static/media/compare-icon.a9f14c8ca282f11505ac814b81c82e0f.svg";
export { ForwardRef as ReactComponent };